import { useMemo } from 'react';
import { useAppSelector } from 'store/hooks';
import { UserAuth } from 'store/auth';
import { Highcharts } from 'components/chart/Chart';

// Used only if the brand theme has no charting colors configured yet — falls back to
// Highcharts' own default series colors, so it matches what the chart would show anyway.
const FALLBACK_CHART_COLOR_PALETTE = ((Highcharts.getOptions().colors ?? []) as Array<string>).map((color) =>
    color.toUpperCase(),
);

// Default color palette for chart series/overlays: the brand theme's configured charting
// colors (sorted by display order), falling back to Highcharts' own defaults when the brand
// theme has none configured.
export default function useChartColorPalette(): Array<string> {
    const userAuth: UserAuth = useAppSelector((state) => state.auth);
    const chartingColors = userAuth?.userInfo?.brandThemeProperties?.charting_colors;

    return useMemo(() => {
        if (!Array.isArray(chartingColors) || chartingColors.length === 0) {
            return FALLBACK_CHART_COLOR_PALETTE;
        }
        return [...chartingColors]
            .sort((a, b) => a.display_order - b.display_order)
            .map((c) => c.line_color.toUpperCase());
    }, [chartingColors]);
}
